import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const SuitcaseIcon: FC<Props> = ({ className, size = 20, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 4H17V19H18C19.1 19 20 18.1 20 17V6C20 4.9 19.1 4 18 4ZM0 6V17C0 18.1 0.899 19 2 19H3V4H2C0.899 4 0 4.9 0 6ZM13.5 1.906C12.819 1.59 11.611 1 9.981 1C8.348 1 7.181 1.59 6.5 1.906V4H4V19H16V4H13.5V1.906V1.906ZM12 4H8V2.664C8.534 2.434 9.078 2.199 9.981 2.199C10.883 2.199 11.467 2.433 12 2.664V4Z" />
    </svg>
  );
};
